export default function isMetrics(stateName) {
  return stateName === "newMetric" || stateName === "savedMetric";
}
